import React, { ReactElement } from 'react';
import { changeLanguage, t } from 'i18next';
import styled from 'styled-components';
import { Locale } from '@oneaudi/avp-hck-dga-customerui-commons';
import logo from '../../assets/spinner/LOGO_CUPRA.png';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 5rem;

  img {
    width: 10rem;
  }
`;

const StyledTitle = styled.h2`
  margin: 2rem;
`;

interface ExpiredProps {
  locale: Locale;
}

export const ExpiredSite = (props: ExpiredProps): ReactElement => {
  const { locale } = props;
  changeLanguage(locale);

  return (
    <StyledContainer>
      <img src={logo} alt="Cupra" />
      <StyledTitle data-testid="expired-title">{t(`giveaway.expired.title`)}</StyledTitle>
      <p data-testid="expired-message">{t(`giveaway.expired.message`)}</p>
    </StyledContainer>
  );
};
